import { getI18n } from '@/plugins/i18n'
import { useLookup } from '@/composables/data-grid'

import { useRegistryStore } from '@/stores/registry.store'

export const useColumns = () => {
  const i18n = getI18n()
  const registryStore = useRegistryStore()

  return [
    {
      type: 'buttons',
      buttons: [{ template: 'editButtonsTemplate' }],
      width: '4rem',
      visibleIndex: 0,
      fixed: false
    },
    {
      caption: i18n.t('common.name'),
      dataField: 'name',
      validationRules: [{ type: 'required' }],
    },
    {
      caption: i18n.t('common.nameExt'),
      dataField: 'name_ext',
      validationRules: [{ type: 'required' }],
    },
    {
      caption: i18n.t('common.color'),
      dataField: 'color',
      cellTemplate: 'colorCellTemplate',
      validationRules: [{ type: 'required' }],
    },
    {
      caption: i18n.t('common.branch'),
      dataField: 'branch',
      lookup: useLookup({ store: registryStore.getLocalizedBranches() }),
    },
    {
      caption: i18n.t('common.employmentStartDate'),
      dataField: 'employment_start_date',
      dataType: 'date',
    },
    {
      caption: i18n.t('common.employmentEndDate'),
      dataField: 'deleted_at',
      dataType: 'date',
    },
  ]
}
